import { Component, Input, AfterViewInit, inject } from '@angular/core';
import { CoreUtilsService, selectorCoreLogin } from '@bepatient/core';
import { Store } from '@ngrx/store';
import chroma from 'chroma-js';
import { take } from 'rxjs';

@Component({
  selector: 'bepatient-my-account-icon',
  templateUrl: './my-account-icon.component.html',
  styleUrls: ['./my-account-icon.component.scss'],
  standalone: false
})
export class MyAccountIconComponent implements AfterViewInit {
  private store$ = inject<Store<any>>(Store);
  private coreUtilsService = inject(CoreUtilsService);

  _color: string;
  _color_alpha: string;
  loginID: string;

  @Input() icon: string;
  @Input() set color(value: string) {
    this._color = value;
    this._color_alpha = value ? chroma(value).alpha(0.2).css() : value;
  }
  @Input() title: string;
  @Input() showUserID: boolean;

  ngAfterViewInit(): void {
    this.store$
      .select(selectorCoreLogin)
      .pipe(take(1))
      .subscribe(loginData => {
        if (loginData && loginData.iAuth && loginData.loginId) {
          this.loginID = this.coreUtilsService.base64ToText(loginData.loginId);
        }
      });
  }
}
